<template>
  <div
    class="tile"
    :class="{'tile--selected': $props.selected }"
  >
    <div class="tile__inner">
      <slot name="leading" />

      <div
        class="title-2"
        v-html="$props.label"
      />
    </div>

    <slot name="marker">
      <the-icon
        v-show="$props.selected"
        art="solid"
        class="tile__marker"
        name="check"
      />
    </slot>
  </div>
</template>

<script setup>
  // INIT
  defineProps({
    label: {
      type: String,
      required: true
    },

    selected: {
      type: Boolean,
      default: false
    }
  })
</script>

<style scoped>
  .tile {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: var(--fixed-spacing-fix-04);
    padding: var(--fixed-spacing-fix-04);
    border-radius: var(--Input-fields-input-border-radius);
    background: var(--Interaction-States-Default-unselected-enabled-b);
    box-shadow: var(--elevation-level-1);
    transition: all var(--duration-short-2) var(--linear);

    &:hover {
      background: var(--Interaction-States-Default-unselected-hovered-b, #F3F2F0);
      box-shadow: var(--elevation-level-1);
      color: var(--Interaction-States-Default-unselected-hovered-a, #00765A);
      cursor: pointer;
    }

    &:active {
      background: var(--Interaction-States-Default-unselected-pressed-b, #E7EDEC);
      box-shadow: var(--elevation-level-1);
    }

    &--selected {
      background: var(--Interaction-States-Default-selected-hovered-b, #EBFDED);
      box-shadow: var(--elevation-level-1);
      color: var(--Interaction-States-Default-selected-enabled-a2, #00765A);

      .tile__marker {
        color: var(--Interaction-States-Chips-Positives-on-selected-enabled-positive);
      }
    }
  }

  .tile__inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--fixed-spacing-fix-04);

    &:deep(.icon) {
      font-size: 32px;
    }
  }

  .tile__marker {
    font-size: 16px;
  }
</style>
